import React from 'react';

import { observer } from 'mobx-react';
import classNames from 'classnames';
import { AvatarIcon } from '@infoods/lifebase-ui';

import classes from './CustomerInfo.module.scss';
import { Point } from '../../../../../../shared/components/ui-components';
import { scanIqCustomerProfileStore } from '../../../../../stores/scanIqCustomerProfileStore';
import { calculateFullYears } from '../../../../../../shared/utils/dateUtils';
import { CustomerStatus } from './CustomerStatus/CustomerStatus';
import { getValueOrDash } from '../../../../../../shared/utils/stringUtils/getValueOrDash/getValueOrDash';

const CustomerInfo = observer(() => {
  const { customerProfileInfo } = scanIqCustomerProfileStore;

  if (!customerProfileInfo) {
    return null;
  }

  const { personalData } = customerProfileInfo;

  const displayName = [personalData.firstName, personalData.lastName]
    .filter(Boolean)
    .join(' ');

  const ageValue = getValueOrDash(calculateFullYears(personalData.dateOfBirth), ' years');
  const genderValue = getValueOrDash(personalData.gender);

  return (
    <div className={classes.container}>
      <AvatarIcon
        size="large"
        userName={personalData.firstName || undefined}
        className="private-info"
      />
      <div className={classes.customerInfo}>
        <p className={classNames(classes.customerName, 'private-info')}>
          {/* show some info in case of incomplete customer */}
          {getValueOrDash(displayName || personalData.phone || null)}
        </p>
        <div className={classes.additionalInfo}>
          <p>
            {genderValue}, {ageValue}
          </p>
          <Point />
          <CustomerStatus />
        </div>
      </div>
    </div>
  );
});

export { CustomerInfo };
